export default __webpack_public_path__ + "453f5c351319d2766b245d33cfffad37.png";